"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames3 = _interopRequireDefault(require("classnames"));

var _reactAnimateHeight = _interopRequireDefault(require("react-animate-height"));

var _Icon = _interopRequireDefault(require("../../general/Icon"));

var _Text = _interopRequireDefault(require("../../typography/Text"));

var _overrides = require("../../../utils/overrides");

var _styles = require("../../../utils/styles");

var _styles2 = _interopRequireDefault(require("./styles"));

var useStyles = (0, _styles.createUseStyles)(_styles2.default, 'Section');

var _ref2 = /*#__PURE__*/_react.default.createElement(_Icon.default, {
  name: "chevron",
  size: "small"
});

function Section(_ref) {
  var isOpenProp = _ref.isOpen,
      children = _ref.children,
      classesProp = _ref.classes,
      overridesProp = _ref.overrides,
      classNameProp = _ref.className,
      title = _ref.title,
      isExpandable = _ref.isExpandable,
      defaultOpen = _ref.defaultOpen,
      onChange = _ref.onChange,
      props = (0, _objectWithoutProperties2.default)(_ref, ["isOpen", "children", "classes", "overrides", "className", "title", "isExpandable", "defaultOpen", "onChange"]);
  var classes = (0, _overrides.useClasses)(useStyles, classesProp);

  var _useState = (0, _react.useState)(onChange ? isOpenProp : defaultOpen),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      isOpen = _useState2[0],
      open = _useState2[1];

  (0, _react.useEffect)(function () {
    if (onChange) open(isOpenProp);
  }, [isOpenProp, onChange]); // Overrides

  var override = (0, _overrides.getOverrides)(overridesProp, Section.overrides); // Classes

  var rootClassName = (0, _classnames3.default)(classes.root, {}, classNameProp);
  var headerClassName = (0, _classnames3.default)(classes.header, (0, _defineProperty2.default)({}, classes.isExpandable, isExpandable));
  var iconClasses = (0, _classnames3.default)(classes.icon, (0, _defineProperty2.default)({}, classes.collapsed, !isOpen));
  var onToggle = (0, _react.useCallback)(function () {
    onChange && onChange(!isOpen);
    !onChange && open(!isOpen);
  }, [isOpen, onChange]);
  var renderTitle = (0, _react.useMemo)(function () {
    if (typeof title === 'string') {
      return /*#__PURE__*/_react.default.createElement(_Text.default, (0, _extends2.default)({
        type: "bold",
        className: classes.Text
      }, override.Text), title);
    }

    return title;
  }, [classes.Text, override.Text, title]);

  if (title && isExpandable) {
    return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({
      className: rootClassName
    }, override.root), /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({
      className: headerClassName,
      onClick: onToggle
    }, override.header), renderTitle, /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({
      className: iconClasses
    }, override.icon), _ref2)), /*#__PURE__*/_react.default.createElement(_reactAnimateHeight.default, (0, _extends2.default)({
      height: isOpen ? 'auto' : 0
    }, override['react-animate-height']), children));
  } else if (title && !isExpandable) {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: rootClassName
    }, /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({
      className: headerClassName
    }, override.header), renderTitle), children);
  }

  return /*#__PURE__*/_react.default.createElement("div", {
    className: rootClassName
  }, children);
}

Section.overrides = ['root', 'header', 'Text', 'react-animate-height'];
Section.defaultProps = {
  isExpandable: true,
  defaultOpen: true,
  overrides: {}
};
process.env.NODE_ENV !== "production" ? Section.propTypes = {
  className: _propTypes.default.string,
  overrides: _propTypes.default.object,
  title: _propTypes.default.any,
  defaultOpen: _propTypes.default.bool,
  isExpandable: _propTypes.default.bool
} : void 0;

var _default = /*#__PURE__*/_react.default.memo(Section);

exports.default = _default;